import React, { useRef } from 'react'
import Hero from './Hero Section/Hero'
import About from './description/About'
import Header from './Hero Section/Header'
import Partner from './description/Partner'
import Solution from './solution/Solution'
import Activies from './activities/Activies'
import Application from './app/Application'
import Contact from './contact/Contact'
import Footer from './footer/Footer'
import Afrogotech from '../assets/avatar.png'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import ProgressBar from './ProgressBar'
import Side from './Hero Section/Side'
import Presentation from './description/Presentation'
import Break from './Break'
import DarkModeSide from './DarkModeSide'
import Scroll from './Scroll'

export default function Landing() {
  const message = "Bonjour ! 🤝 \nComment pouvons-nous vous aider ?"
  const solutionRef = useRef(null);
  const activiesRef = useRef(null);
  const aboutRef = useRef(null);
  
  return (
    <>
      <Side/>
      <Header solutionRef={solutionRef} activiesRef={activiesRef} aboutRef={aboutRef}/>
      <Hero/>
      <DarkModeSide/>
      <Scroll/>
      <About aboutRef={aboutRef}/>
      <Presentation/>
      <Solution solutionRef={solutionRef}/>
      <Activies activiesRef={activiesRef}/>
      <Break/>
      <Partner/>
      <Application />
      <Contact/>
      <Footer />
      <FloatingWhatsApp accountName="Afrogotech Support" phoneNumber="+212608112112" avatar={Afrogotech} statusMessage='Généralement, réponses dans 1h' chatMessage={message}/>
      <ProgressBar/>
      
    </>
  );
}
